exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".direction-picker_button-row_33xQd {\r\n    justify-content: center;\r\n    margin-bottom: 1rem;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"button-row": "direction-picker_button-row_33xQd",
	"buttonRow": "direction-picker_button-row_33xQd"
};